import Vue from 'vue'
import Loading from './globalLoading.vue'

const _Constructor = Vue.extend(Loading)

let instance

const show = (opts) => {
  const defaultOpts = {}

  if (typeof opts === 'string') {
    defaultOpts.message = opts
  } else {
    Object.assign(defaultOpts, opts)
  }
  
  if (!instance) {
    instance = new _Constructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }

  instance.visible = true

  for (const key in defaultOpts) {
    if (Object.hasOwnProperty.call(defaultOpts, key)) {
      instance[key] = defaultOpts[key]
    }
  }
}

const hide = () => {
  if (instance) {
    instance.visible = false
  }
}

export default {
  install(Vue) {
    Vue.prototype.lyfLoading = show
    Vue.prototype.lyfHideLoading = hide
  }
}